module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraLight.54a4bb85.ttf";